import { render, staticRenderFns } from "./SelectRecordTable.vue?vue&type=template&id=5024e926&"
import script from "./SelectRecordTable.vue?vue&type=script&lang=js&"
export * from "./SelectRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports